var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-item-overlay" }, [
    _vm.allowReplace
      ? _c(
          "div",
          {
            directives: [
              {
                name: "b-tooltip",
                rawName: "v-b-tooltip.hover",
                modifiers: { hover: true },
              },
            ],
            staticClass: "c-item-overlay__item add-item replace-item",
            attrs: { title: "Replace with selected" },
            on: { click: _vm.switchItems },
          },
          [
            _c("b-icon", {
              staticStyle: {
                stroke: "#479382",
                color: "#fff",
                "stroke-width": "1.5px",
              },
              attrs: { icon: "arrow-left-right", "font-scale": "1.1" },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "c-item-overlay__item delete-item",
        on: { click: _vm.decreaseCount },
      },
      [
        _c("b-icon", {
          staticStyle: {
            color: "#479382",
            stroke: "#fff",
            "stroke-width": "1.5px",
          },
          attrs: { icon: "dash-circle-fill", "font-scale": "1.3" },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "c-item-overlay__item count" }, [
      _c("span", { staticClass: "count-text" }, [
        _vm._v("\n      " + _vm._s(_vm.countOfItem) + "\n    "),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "c-item-overlay__item add-item",
        on: { click: _vm.addItem },
      },
      [
        _c("b-icon", {
          staticStyle: {
            color: "#479382",
            stroke: "#fff",
            "stroke-width": "1.5px",
          },
          attrs: { icon: "plus-circle-fill", "font-scale": "1.3" },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }